import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import CloudOffTwoToneIcon from "@material-ui/icons/CloudOffTwoTone";
import HistoryIcon from "@material-ui/icons/History";

import { Title } from "react-admin";

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        padding: "1em",
      },
      fontFamily: "Roboto, sans-serif",
      opacity: 0.5,
    },
    title: {
      display: "flex",
      alignItems: "center",
    },
    icon: {
      width: "10em",
      height: "10em",
      marginRight: "0.5em",
    },
    toolbar: {
      marginTop: "2em",
    },
  }),
  { name: "RaError" }
);

function goBack() {
  window.history.go(-1);
}

//  in src/MyLayout.js
// import { Layout } from 'react-admin';
// import NetorkError from './NetworkError';
// const MyLayout = (props) => <Layout {...props} error={MyError} />;

const NetworkError = (props) => {
  const classes = useStyles(props);
  const { pathname } = useLocation();
  const originalPathname = useRef(pathname);
  const { error, errorInfo, resetErrorBoundary, history, ...rest } = props;

  // Effect that resets the error state whenever the location changes
  useEffect(() => {
    if (pathname !== originalPathname.current) {
      resetErrorBoundary();
    }
  }, [pathname, resetErrorBoundary]);

  return (
    <>
      <Title title="Network Error" />
      <div className={classes.container} {...rest}>
        <h1 className={classes.title} role="alert">
          <CloudOffTwoToneIcon className={classes.icon} />
        </h1>
        <h1 className={classes.title} role="alert">
          Network Error
        </h1>
        <Typography>
          Your internet connection is unstable. Please check your connection and
          try again.
        </Typography>

        <div className={classes.toolbar}>
          <Button
            variant="contained"
            startIcon={<HistoryIcon />}
            onClick={goBack}
          >
            Back
          </Button>
        </div>
      </div>
    </>
  );
};

export default NetworkError;
